import { render } from "./HeaderProfile.vue?vue&type=template&id=458b7820"
import script from "./HeaderProfile.vue?vue&type=script&lang=js"
export * from "./HeaderProfile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__